<script setup>
import ButtonSubmit from "./ButtonSubmit.vue";
import Swal from 'sweetalert2'
import api from "../api/api";
</script>

<template>
    <div class="main-div">
         <div class="card-header">
            <div class="card-header-title">{{ label }}</div>
            <div style="display: flex; align-items: center; gap: 8px;">
              <button class="pill-btn" @click.prevent="toggle = !toggle" v-show="!toggle">Show</button>
              <button class="pill-btn" @click.prevent="toggle = !toggle" v-show="toggle">Hide</button>
            </div>
        </div>
        <div class="parent" v-show="toggle" v-if="pdfs.length == 0">
            <h2>No PDFs available.</h2>
        </div>

        <div class="parent" v-show="toggle" v-if="pdfs.length > 0">
            <div class="child" v-for="pdf in pdfs" :key="pdf">
            <div>
                <h2>{{ cleanPdfName(pdf.name) }}</h2>
                <p>{{ formatDate(pdf.modified) }}</p>
            </div>
            <div style="display: flex; justify-content: center; margin: 10px 0;">
                <img class="surveyLogo" src="../../public/PDFlogo.png" style="width: 50%; height: auto;" />
            </div>
            <ButtonSubmit label="Open" style="margin-top: 10px" @click="showPdf(pdf)" />
            <ButtonSubmit label="Delete" style="margin-top: 10px;" @click="deletePdf(pdf)" />
            </div>
        </div>

    </div>
</template>

<script>
export default {
    components: [ButtonSubmit],
    name: "HomePDF",
    props: ["userData", "brandData", "pdfData", "label"],
    data: () => ({
        toggle: true,
        pdfs: [],
        setLoading: false,
        abortController: new AbortController(),  
    }),
    methods: {

        async deletePdf(pdf) {
            const confirmDelete = confirm(`Permanently delete ${pdf.name} from the TalentSage system?`);
            if (!confirmDelete) return;

            try {
                const requestBody = {
                    ind_id: Array.isArray(this.userData.ind_id) ? this.userData.ind_id : [this.userData.ind_id],
                    pdfName: pdf.name,
                };


                const response = await api.post('/delete-PDF-by-user', requestBody);

                if (response.status === 200) {
                    alert("PDF deleted successfully");

                    // Update pdfs array
                    this.pdfs = this.pdfs.filter((p) => p.name !== pdf.name);

                    // Create user history log
                    try {
                        await api.post(`/create-user-history-log`, {
                            ind_id: this.userData.ind_id,
                            email: this.userData.email,
                            screen: "Menu Icons top right",
                            action: `Delete PDF`,
                            action_description: `Deleted PDF: ${pdf.name}`,
                        });
                    } catch (error) {
                        console.error("Error in user-history-log API:", error);
                    }
                } else {
                    alert(response.data.message);
                }
            } catch (error) {
                console.error('Error deleting PDF:', error);
                alert("Error deleting PDF. Please try again later.");
            }
        },


        cleanPdfName(name) {
            return name ? name.replace(/\.pdf$/i, '') : ''; // Removes .PDF/.pdf (case-insensitive)
        },

        formatDate(date) {
            return date ? new Date(date).toLocaleString() : "N/A";
        },

        async showPdf(pdf) {
            this.setLoading = true;
            let url = null;
            if (this.setLoading === true) {
                this.showPdfAlert();
            }
            try {
                const requestBody = {
                    ind_id: this.userData.ind_id,
                    pdfName: pdf.name,
                };

                const response = await api.post('/open-pdf-by-user', requestBody, {
                    responseType: 'blob', // Specify the response type as blob,
                    signal: this.abortController.signal,
                });

                // Create a blob URL from the response data
                const blob = new Blob([response.data], { type: 'application/pdf' });
                url = window.URL.createObjectURL(blob);

                if (url !== null) {
                    window.open(url, '_blank');
                    this.setLoading = false;
                    if (this.setLoading === false) {
                        this.hidePdfAlert();
                    }
                }
            } catch (error) {
                if (error.message == 'canceled') {
                    return;
                } 
                else {
                    Swal.fire({
                        title: '',
                        text: 'A pdf is not available. TalentSage Support have been notified and will contact you when the issue has been resolved',
                        icon: 'warning',
                        confirmButtonText: 'Ok',
                        confirmButtonColor: '#3085d6',
                        allowOutsideClick: false,
                    });
                    console.error('Error downloading PDF:', error);
                }
            }
        },

        async showPdfAlert() {
            Swal.fire({
                title: "Preparing your pdf, please wait...",
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });
        },
        async hidePdfAlert(){
            Swal.close()
        }
    },
    mounted() {

        if(this.pdfData){
        this.pdfs = this.pdfData
        }

    },
    watch: {
    pdfData(newVal) {
      if (newVal) {
        this.pdfs = this.pdfData
      }
    },
  },
};
</script>

<style scoped>
.main-div {
  min-width: 75vw;
  margin: 0;
  font-family: var(--font-family, 'Inter', sans-serif);
}
.card-header {
  padding: var(--space-sm, 16px);
  background: var(--card-bg, #ffffff);
  border: 1px solid var(--card-border, #e2e8f0);
  border-bottom: none;
  border-radius: var(--radius-lg, 0.5rem) var(--radius-lg, 0.5rem) 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.card-header-title {
  font-size: var(--label-md-size, 12px);
  font-weight: 600;
  letter-spacing: var(--label-md-tracking, 0.05em);
  text-transform: uppercase;
  color: v-bind('brandData.main_color1 ? brandData.main_color1 : "#002955"');
}
.pill-btn {
  background: #ffffff;
  color: v-bind('brandData.main_color1 ? brandData.main_color1 : "#002955"');
  border: 1px solid v-bind('brandData.main_color1 ? brandData.main_color1 : "#002955"');
  border-radius: 9999px;
  padding: 6px 16px;
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s ease;
  font-weight: 500;
  font-family: var(--font-family, 'Inter', sans-serif);
  text-transform: none;
  letter-spacing: 0;
  white-space: nowrap;
  flex-shrink: 0;
}
.pill-btn:hover {
  background: v-bind('brandData.main_color1 ? brandData.main_color1 : "#002955"');
  color: #ffffff;
}
.parent {
  display: flex;
  flex-wrap: wrap;
  padding: var(--space-sm, 16px);
  background: var(--card-bg, #ffffff);
  border: 1px solid var(--card-border, #e2e8f0);
  border-top: none;
  border-radius: 0 0 var(--radius-lg, 0.5rem) var(--radius-lg, 0.5rem);
}
.child {
  background: var(--card-bg, #ffffff) !important;
  border: 1px solid var(--card-border, #e2e8f0);
  border-radius: var(--radius-lg, 0.5rem);
  text-align: center;
  min-width: 205px;
  max-width: 205px;
  margin: var(--space-xs, 8px);
  padding: var(--space-sm, 16px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: none;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
}
.child:hover {
  box-shadow: var(--shadow-hover, 0px 4px 20px rgba(18, 63, 117, 0.05));
  border-color: var(--primary-container, #123f75);
}
.surveyLogo { width: 150px; height: auto; }

@media only screen and (min-width: 280px) and (max-width: 540px) {
  .main-div { margin: 0; }
}
</style>